import React from "react";
import { useSelector } from "react-redux";
import { getBizTimeSummary } from "../../function/store";
import { MenuBoardDetails } from "../../styled/setting";

const Details = ({ company, selectCompany, visibleMode = "" }) => {
  const companyData = useSelector((state) => state?.company?.data).find(
    (cmpny) => String(cmpny.cmpnyNo) === String(selectCompany.value),
  );

  const renderData = [
    {
      title: company?.cmpnyNm,
      type: "fields",
      visible: visibleMode !== "info" && visibleMode !== "time",
      items: [
        {
          visible: !!company?.addr,
          label: "주소",
          value: `${company?.addr} ${company?.addrDetail}`,
        },
        {
          visible: !!company?.rprNm,
          label: "대표자명",
          value: company?.rprNm,
        },
        {
          visible: !!companyData?.bizrno,
          label: "사업자등록번호",
          value: companyData.bizrno,
        },
        {
          visible: !!companyData?.cmpnyNm,
          label: "상호명",
          value: companyData.cmpnyNm,
        },
      ],
    },
    {
      title: "영업시간",
      type: "textList",
      visible: visibleMode !== "info",
      items: getBizTimeSummary(company?.businessHours),
    },
    {
      title: "공지사항",
      type: "text",
      content: company?.notice,
      visible: visibleMode !== "time",
    },
    {
      title: "원산지 정보",
      type: "text",
      content: company?.originInfo,
      visible: visibleMode !== "time",
    },
  ];

  return (
    <MenuBoardDetails>
      {renderData
        .filter((item) => item.visible)
        .map((section, i) => (
          <div key={i} className="section">
            <h3>{section.title}</h3>
            {section.type === "fields" &&
              section.items
                .filter((item) => item.visible)
                .map((item, idx) => (
                  <p key={idx}>
                    <span>{item.label}:</span> {item.value}
                  </p>
                ))}
            {section.type === "textList" &&
              section.items.map((item, idx) => <p key={`${item.key}-${idx}`}>{item}</p>)}
            {section.type === "text" && <p>{section.content}</p>}
          </div>
        ))}
    </MenuBoardDetails>
  );
};

export default Details;
